<script setup>
import Button from '@components/global/button.vue'
defineProps(['item'])
</script>
<template>
	<Button class="w-full" :to="{ name: 'merch-item', params: { slug: item.slug } }" :content="true">
		<article class="relative flex h-full w-full flex-col items-center gap-2 overflow-hidden rounded-large border border-sf-purple-base bg-bg-dark">
			<div class="w-full p-6">
				<div class="mb-2 h-5 text-body-md font-medium capitalize text-text-muted/50 md:text-h6">
					<span v-if="item.type">{{ item.type }}</span>
				</div>
				<h5 class="mb-6 line-clamp-1 text-h6 font-semibold md:text-h5">
					{{ item.title }}
				</h5>
			</div>
			<img :src="item.image" alt="" class="h-full max-h-[200px] w-full max-w-[200px] object-contain pt-4" />
			<div class="flex w-full gap-2 p-8 text-body-lg font-medium text-text-base">
				<span v-if="item.compare_at_price" class="line-through">
					{{ item.compare_at_price }}
				</span>
				<span class="font-bold">{{ item.price }}</span>
			</div>
		</article>
	</Button>
</template>
